export default __webpack_public_path__ + "static/media/Icon-plus-gray.34e33921.svg";